var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54691 8.54581L5.5213 7.3549L7.49569 8.56148L6.97859 6.30503L8.71794 4.80073L6.43015 4.59703L5.5213 2.46594L4.61246 4.58136L2.32467 4.78506L4.06402 6.30503L3.54691 8.54581ZM2.59106 9.86081L3.36859 6.53036L0.78418 4.29209L4.18812 3.99672L5.5213 0.856812L6.85449 3.99672L10.2584 4.29209L7.67402 6.53036L8.45155 9.86081L5.5213 8.09264L2.59106 9.86081Z",
    fill: "#2A2D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg2);
export default __webpack_public_path__ + "static/media/filterImg2.92c7b851a7aa105a73fa9dd64571ac1c.svg";
export { ForwardRef as ReactComponent };